export default {
  SET_INPUT_FILLED_COUNT_LIST(state, data) {
    state.inputFilledCountList = data;
  },
};
